// extracted by mini-css-extract-plugin
export default {"wrapper":"ap-z","response":"bp-z","error":"cp-z","disabled":"dp-z","buttons":"ep-z","feedbackQuestionSection":"fp-z","yesNoWrapper":"gp-z"};